module.exports = __webpack_public_path__ + "float_bc.5411c2b4.png";